__turbopack_context__.v({
  "axis": "state-chips-module__WMly8q__axis",
  "run": "state-chips-module__WMly8q__run",
});
